import CreateInvestmentError from './CreateInvestmentError';
class CouponIsNotActive extends CreateInvestmentError {
    constructor(options) {
        super('Coupon is not active for be used', options);
    }
}
export default CouponIsNotActive;
